import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";
import { DetailPageLayout } from "../components";
import { showEvents } from "../selectors/event";

const mapStateToProps = ({ language, t, event, eventPage }) => {
  return {
    language,
    t,
    events: _.get(event, "data"),
    eventPage: _.get(eventPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class EventDetail extends Component {
  render() {
    const id = this.props.match.params.id;
    const { events, eventPage, t } = this.props;
    const video = _.get(eventPage, "video");
    const imageBanner = _.get(eventPage, "imageBanner");
    const imageBannerMobile = _.get(eventPage, "imageBannerMobile");

    const showItems = showEvents(events);

    return (
      <DetailPageLayout
        data={showItems}
        id={_.toInteger(id)}
        path="event/detail"
        pageName={t("EVENT")}
        page="events"
        media={video}
        imageBanner={imageBanner}
        imageBannerMobile={imageBannerMobile}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EventDetail.js